import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.div`
    color: #FD5E20;
    cursor: pointer;
    padding: 8px;
    font-size: 14px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    &:before {
        content: "\f00d";
    }
`;


export default Atom({ type: 'button', dataType: 'string', template })